import {
  ProgressionGateTypes,
  ProgressionGateStatus,
} from "types/common-types";
import { SkuProgressionGateWithId } from "types/sku-related-types";

export const isNoneGateType = (gateTypeId: string) =>
  gateTypeId.toLowerCase() === ProgressionGateTypes.None.toLowerCase();

export const getProgressionGateStatus = (
  gates: SkuProgressionGateWithId[]
): ProgressionGateStatus => {
  if (!gates.length) return ProgressionGateStatus.None;

  const isInherited = !gates.some((gate) => gate.skuId);
  const isDeactivated = gates.some(
    (gate) =>
      gate.progressionGateTypeId && isNoneGateType(gate.progressionGateTypeId)
  );

  if (isDeactivated) {
    return ProgressionGateStatus.Deactivated;
  }
  if (isInherited) {
    return ProgressionGateStatus.Inherited;
  }

  return ProgressionGateStatus.Overridden;
};
